<script setup></script>

<template>
  <div class="rounded-16 bg-white p-s dark:bg-gray-950 laptop:p-xl laptop:pt-[26px]">
    <slot></slot>
  </div>
</template>
